import type { Visualize3dLight } from '../models/visualize3d-light';
import type { Visualize3dComponent } from './visualize3d-component';
import type { Visualize3dComponentCreator } from './visualize3d-component-creator';

export interface SpotLightComponent extends Visualize3dLight, Visualize3dComponent {
  angle: number;
  castShadow: boolean;
  decay: number;
  distance: number;
  penumbra: number;
}

export const spotLightComponentCreator: Visualize3dComponentCreator<SpotLightComponent> = {
  createComponent: createSpotLightComponent,
};

/**
 * Create new instance of spot light
 */
export function createSpotLightComponent(): SpotLightComponent {
  return {
    $type: 'MagiCADCore.Visualize3D.ThreeJS.DataTransfer.SpotLightDto, MagiCADCore.Visualize3D.ThreeJS',
    type: 'SpotLight',
    color: '#ffffff',
    intensity: 1,
    angle: Math.PI / 3,
    castShadow: false,
    decay: 1,
    distance: 0.0,
    penumbra: 0.0,
  };
}
